const ToastErrorIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.75744 5.75708L14.2427 14.2424" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M5.75743 14.2425L14.2427 5.75723" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </svg>
  );
};

export default ToastErrorIcon;
